declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
//import { NgbAddBill } from '../modal/addbill.modal';
//import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, OrderData, SaveiahOrderRequest, ConsumptionGroupItemsController, ConsumptionGroupItemsRequest, StoreLocationMaterialsController, StoreLocationMaterialsRequest, MaterialBatchInaStoreController, SaveMaterialConsumptionEntriesRequest, FinalizeConsumptionEntryRequest, SaveAdmissionDetailsRequest, BedLocationsListController, BedLocationsListRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbAddBill } from '../opbilling/modal/addbill.modal';
import { NgbPayBillModal } from '../opbilling/paybill.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
//import { NgbPaymentModal } from './modal/payment.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';
import { ConsumpationData } from '../_MasterClasses/MaterailClasses';




@Component({
  selector: 'newadmission',
  templateUrl: './newadmission.component.html',
  styleUrls: ['./newadmission.component.scss']
  , animations: [routerTransition()]
})

export class NewAdmissionComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  @Input() FormattedCode: string;

  // public ActorCode: number = 0;
  //public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  // public Consumptioncode: number;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowList: boolean = true;
  public Insurancetoggle: boolean = false;
  public PrimaryDoctorO: boolean = true;
  public PrimaryDoctorn: boolean = false;
  public PrimaryDoctor: string;
  public PrimaryCode: number;
  public PrimaryNumber: number;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public Add: boolean = true;
  public Edit: boolean = false;
  public isRequesting: boolean = false;
  public cash: boolean = false;
  public card: boolean = false;
  public cheque: boolean = false;
  public demanddraft: boolean = false;
  public paytm: boolean = false;
  public FormattedCodedata: any;
  public Code: any;
  public TotalBill: number;
  public NetPayable: number;
  public BranchName: string;
  public FacilityCode: number;
  public ActorCode: number;
  public Date: Date;
  public SelectedFromDate: any;
  public SelectedFromDatenew: NgbDateStruct;
  public SelectedToDatenew: NgbDateStruct;
  public SelectedToDate: any;
  public date: Date;
  public date2: Date;
  AdmissionDate: NgbDateStruct;
  TodayDate = new Date();

  PlannedDischargeDate: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  searchTitle: string;
  public SelectedPrescriber: PrescribingDoctor[];
  public SelectedReferral: ReferringDoctor[];
  CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  CurrentSaveMaterialConsumptionEntriesRequest: SaveMaterialConsumptionEntriesRequest;
  CurrentFinalizeConsumptionEntryRequest: FinalizeConsumptionEntryRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;

  CurrentSaveAdmissionDetailsRequest: SaveAdmissionDetailsRequest;

  LoadPatients(FormattedCode: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {


    this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');
    this.Code = this.route.snapshot.paramMap.get('Code');
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.SelectedFromDate = this.route.snapshot.paramMap.get('SelectedFromDate');
    this.date = new Date(this.SelectedFromDate);
    this.SelectedFromDatenew = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() };
    this.SelectedToDate = this.route.snapshot.paramMap.get('SelectedToDate');
    this.date2 = new Date(this.SelectedToDate);
    this.SelectedToDatenew = { year: this.date2.getFullYear(), month: this.date2.getMonth() + 1, day: this.date2.getDate() };
    this.LoadPatients(this.FormattedCodedata);
    this.CurrentSaveAdmissionDetailsRequest = new SaveAdmissionDetailsRequest();
    this.CurrentSaveAdmissionDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveAdmissionDetailsRequest.AdmissionType = 'MEDREFF';
    this.CurrentSaveAdmissionDetailsRequest.CaseType = 'INPAT';
    this.CurrentSaveAdmissionDetailsRequest.TreatmentCategory = 'STDPT';
    this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
    this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveMaterialConsumptionEntriesRequest = new SaveMaterialConsumptionEntriesRequest();
    this.CurrentSaveMaterialConsumptionEntriesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentFinalizeConsumptionEntryRequest = new FinalizeConsumptionEntryRequest();
    this.CurrentFinalizeConsumptionEntryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.Date = new Date();
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.AdmissionDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.BedDetails();
  }

  CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
  CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
  LoadServicesByCategory() {

    this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
    this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
    //this.pdata = this.CurrentServicesByCategoryCodeController;
    this.GetServicesByCategoryCodeController();

  }
  GetServicesByCategoryCodeController() {
    this.StartRefreshing();
    this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
          //  this.pdata = this.CurrentServicesByCategoryCodeController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  toggle() {
    this.Insurancetoggle = true;
  }
  SelectPrimaryDoctor() {
    this.PrimaryDoctorO = false;
    this.PrimaryDoctorn = true;
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.IsShowDoctor = true;
    modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.PrimaryDoctor = receivedEntry.make;
      this.PrimaryCode = receivedEntry.value;
      this.PrimaryNumber = receivedEntry.number;
      this.CurrentSaveAdmissionDetailsRequest.ProviderName = this.PrimaryDoctor;
      this.CurrentSaveAdmissionDetailsRequest.ProviderCode = this.PrimaryCode;
      //alert(this.ProviderName);
    })
  }



  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  cashdata() {
    this.cash = true;
  }
  carddata() {
    this.card = true;
  }
  chequedata() {
    this.cheque = true;
  }
  demanddraftdata() {
    this.demanddraft = true;
  }
  paytmdata() {
    this.paytm = true;
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentStoreLocationMaterialsController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentStoreLocationMaterialsController,
          this.listFilter);
      }
    }
  }
  Consumptioncode: number;
  public ConsumptionGroupName: string;
  onAssignedToActorCodesurgeon(event: any) {

    if (event != null) {
      var Consumptiongroupname = event;
      this.ConsumptionGroupName = Consumptiongroupname;
      this.GroupItems();
      ///this.del_();

      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
      // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  del_() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.GroupItems();
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  CurrentConsumptionGroupItemsRequest: ConsumptionGroupItemsRequest;
  CurrentConsumptionGroupItemsController: ConsumptionGroupItemsController[];
  GroupItems() {

    this.CurrentConsumptionGroupItemsRequest = new ConsumptionGroupItemsRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentConsumptionGroupItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentConsumptionGroupItemsRequest.ConditionalOperator = 10;
    this.CurrentConsumptionGroupItemsRequest.GroupCode = this.Consumptioncode;
    //this.CurrentConsumptionGroupItemsRequest = new Array<ServicesByCategoryCodeController>();

    this.GetConsumptionGroupItemsController();

  }
  GetConsumptionGroupItemsController() {
    this.StartRefreshing();
    this.actorservice.GetConsumptionGroupItemsController(this.CurrentConsumptionGroupItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentConsumptionGroupItemsController = this.ApiResData.Result;
          this.AddData();

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  StoreCode: number;
  public StoreName: string;
  onAssignedToActorCodesurgeon2(event: any) {

    if (event != null) {
      this.StoreName = event;
      this.StoreItems();
      /// this.GroupItems();
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
      // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  CurrentStoreLocationMaterialsRequest: StoreLocationMaterialsRequest;
  CurrentStoreLocationMaterialsController: StoreLocationMaterialsController[];
  StoreItems() {

    this.CurrentStoreLocationMaterialsRequest = new StoreLocationMaterialsRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;

    this.CurrentStoreLocationMaterialsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentStoreLocationMaterialsRequest.ConditionalOperator = 10;
    this.CurrentStoreLocationMaterialsRequest.StoreCode = this.StoreCode;
    this.pdata = this.CurrentStoreLocationMaterialsController;

    this.GetStoreLocationMaterialsController();

  }
  GetStoreLocationMaterialsController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetStoreLocationMaterialsController(this.CurrentStoreLocationMaterialsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentStoreLocationMaterialsController = this.ApiResData.Result;
          this.pdata = this.CurrentStoreLocationMaterialsController;
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  CurrentBedLocationsListRequest: BedLocationsListRequest;
  CurrentBedLocationsListController: BedLocationsListController[];
  BedDetails() {

    this.CurrentBedLocationsListRequest = new BedLocationsListRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;

    this.CurrentBedLocationsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentBedLocationsListRequest.ConditionalOperator = 10;
    this.CurrentBedLocationsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentBedLocationsListRequest.FromDate = new Date();
    this.CurrentBedLocationsListRequest.ToDate = new Date();

    this.GetBedLocationsListController();

  }
  GetBedLocationsListController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetBedLocationsListController(this.CurrentBedLocationsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentBedLocationsListController = this.ApiResData.Result;
          //  this.pdata = this.CurrentStoreLocationMaterialsController;
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  public BedLocationcode: number;
  onChange(Event: any) {
    if (Event != null) {
      var a = this.CurrentBedLocationsListController.filter(X => X.ColumnName === Event)
      if (a.length > 0) {
        this.BedLocationcode = a[0].BedLocationCode;
        this.LoadBedLoaction2();
      }
    }
  }
  CurrentBedLocationsListRequest2: BedLocationsListRequest;
  CurrentBedLocationsListController2: BedLocationsListController[];
  LoadBedLoaction2() {

    this.CurrentBedLocationsListRequest2 = new BedLocationsListRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;

    this.CurrentBedLocationsListRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentBedLocationsListRequest2.ConditionalOperator = 20;
    this.CurrentBedLocationsListRequest2.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentBedLocationsListRequest2.FromDate = new Date();
    this.CurrentBedLocationsListRequest2.ToDate = new Date();
    this.CurrentBedLocationsListRequest2.BedLocationCode = this.BedLocationcode;

    this.GetBedLocationsListController2();

  }
  GetBedLocationsListController2() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetBedLocationsListController(this.CurrentBedLocationsListRequest2)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentBedLocationsListController2 = this.ApiResData.Result;
          //  this.pdata = this.CurrentStoreLocationMaterialsController;
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  Cancel() {
    this.router.navigate(['healins/admissions']);
  }
  docedit() {

    const modalRef = this.modalService.open(NgbAddBill,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.SelectedPrescriber = receivedEntry.make;
      this.SelectedReferral = receivedEntry.value;
      this.LoadServicesByCategory();
      //alert(this.ProvidedName);
    })


  }
  CancelNewOperation() {

    this.ShowList = true;
  }
  back() {
    this.receipt = false;
    this.opbilling = true;
    this.router.navigate(['/healins/opbilling']);
    //this.router.navigate.['/healins/opbilling'];
  }
  payment() {
    const modalRef = this.modalService.open(NgbPayBillModal,
      {
        centered: true,
        size: "lg"
      })
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  CurrentConsumpationData: Array<ConsumpationData>;
  AddData() {

    //this.CurrentConsumpationData = this.CurrentConsumptionGroupItemsController;
    this.CurrentConsumpationData = new Array<ConsumpationData>();
    this.CurrentConsumptionGroupItemsController.forEach((v, i, d) => {
      var item = new ConsumpationData();
      item.ItemCode = v.ItemCode;
      item.ItemName = v.ItemName;
      item.Quantity = 1;
      item.ItemCost = 0;
      item.Uom = v.Uom;
      item.GroupCode = v.GroupCode;
      item.SupplierBatchDetails = "0";
      this.CurrentConsumpationData.push(item);
    });
    //if (this.CurrentConsumpationData.length == 0) {
    //    this.del_();
    //}

  }








  // CurrentOrderData: Array<OrderData>;
  AddRow(l: StoreLocationMaterialsController) {
    if (this.CurrentConsumpationData == null) {
      this.CurrentConsumpationData = new Array<ConsumpationData>();
    }
    if (this.CurrentConsumpationData != null) {
      var row = new ConsumpationData();
      row.ItemName = l.Description;
      row.ItemCode = l.MaterialSpec;
      row.Quantity = 1;
      row.ItemCost = 0;
      row.SupplierBatchDetails = "0";
      // row.Quantity = 1;
      // row.PackageName = l.CategoryName;
      // row.DiscountAllowed = l.DiscountAllowed;
      //row.ChargeItemCode = 0;
      this.CurrentConsumpationData.push(row);

    }

    // this.TotalBill = this.CurrentConsumptionGroupItemsController.filter((item) => item.ItemCost)
    //   .map((item) => +item.ItemCost)
    //  .reduce((sum, current) => sum + current);

    // this.BranchName = AppData.Instance().SelectedBranchName;
    // this.Date = new Date();
    //        alert(l.BasePrice);

    //this.AddData();

  }
  CurrentNewBillData: NewBillData;

  //AddData() {
  //    this.CurrentNewBillData = new NewBillData();
  //    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;


  //    this.CurrentNewBillData.BillDate = new Date();
  //    this.CurrentNewBillData.BillSource = "Internal";
  //    this.CurrentNewBillData.BillStatus = "";
  //    this.CurrentNewBillData.BillType = "OP";
  //    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
  //    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
  //    this.CurrentNewBillData.ChargeEntryCode = 0;
  //    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
  //    this.CurrentNewBillData.Items = this.CurrentBillDetails;
  //    this.CurrentNewBillData.PrescriberDoctor = this.SelectedPrescriber;
  //    this.CurrentNewBillData.ReferringDoctor = this.SelectedReferral;
  //    this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
  //    this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
  //    this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
  //    this.CurrentNewBillData.TotalDiscount = 0;
  //    this.CurrentNewBillData.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
  //       .map((item) => +item.ItemRate)
  //        .reduce((sum, current) => sum + current);
  //    this.CurrentNewBillData.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
  //      .map((item) => +item.ItemRate)
  //        .reduce((sum, current) => sum + current);
  //    //this.CurrentNewBillData
  //    this.SaveData();


  //}

  onSubmit() {
    this.spinner.show();
    this.CurrentSaveAdmissionDetailsRequest.ConditionalOperator = 10;
    this.CurrentSaveAdmissionDetailsRequest.AdmissionDate = new Date(this.parserFormatter.format(this.AdmissionDate));
    this.CurrentSaveAdmissionDetailsRequest.PlannedDischargeDate = new Date(this.parserFormatter.format(this.PlannedDischargeDate));
    this.CurrentSaveAdmissionDetailsRequest.PatientCode = this.SelectedPatientFormattedCode.PatientRegistrationNumber;
    this.CurrentSaveAdmissionDetailsRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    //this.CurrentSaveAdmissionDetailsRequest.CareUnitCode = 0;
    this.CurrentSaveAdmissionDetailsRequest.ServiceCategoryCode = 0;
    this.CurrentSaveAdmissionDetailsRequest.AdmissionStatus = "ADMTD";
    this.CurrentSaveAdmissionDetailsRequest.RoomNo = "";
    this.CurrentSaveAdmissionDetailsRequest.Ward = "";
    this.CurrentSaveAdmissionDetailsRequest.TpiApprovalStatus = "";
    this.CurrentSaveAdmissionDetailsRequest.TpiApprovalStatus = "";
    this.CurrentSaveAdmissionDetailsRequest.CareUnitType = "";
    this.CurrentSaveAdmissionDetailsRequest.AdmissionReason = "";
    this.CurrentSaveAdmissionDetailsRequest.CareUnitLocation = "";
    this.CurrentSaveAdmissionDetailsRequest.ReferralCode = this.SelectedPatientFormattedCode.RefCode;
    this.CurrentSaveAdmissionDetailsRequest.ReferralName = this.SelectedPatientFormattedCode.RefferingDoctor;
    this.CurrentSaveAdmissionDetailsRequest.ProposedTreatment = "";
    this.CurrentSaveAdmissionDetailsRequest.Instructions = "";
    this.CurrentSaveAdmissionDetailsRequest.LastModifiedUser = AppData.Instance().UserLoginDetails.ActorCode;
    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);

    this.actorservice.SaveAdmissionDetails(this.CurrentSaveAdmissionDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //alert(this.ApiResData);
          if (this.ApiResData.Result > 0 || this.ApiResData.Remarks == "Success") {
            //this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.router.navigate(['testnurse/profileview']);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);

          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  SaveData() {
    this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveBillItemsInfoRequest.ChargeEntry = "0";
    this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 10;
    this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            // this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            //this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            //this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            //this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  SaveDataConsumption() {
    this.CurrentSaveMaterialConsumptionEntriesRequest.ConditionalOperator = 10;
    this.CurrentSaveMaterialConsumptionEntriesRequest.ConsumptionCode = 0;
    this.CurrentSaveMaterialConsumptionEntriesRequest.OwnerLocation = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveMaterialConsumptionEntriesRequest.OwnerLocationName = AppData.Instance().UserLoginDetails.FacilityName;
    this.CurrentSaveMaterialConsumptionEntriesRequest.PatientCode = this.SelectedPatientFormattedCode.PatientRegistrationNumber;
    this.CurrentSaveMaterialConsumptionEntriesRequest.PatientFormattedCode = this.FormattedCodedata;
    this.CurrentSaveMaterialConsumptionEntriesRequest.PatientName = this.SelectedPatientFormattedCode.DisplayName;
    this.CurrentSaveMaterialConsumptionEntriesRequest.Remarks = "";
    this.CurrentSaveMaterialConsumptionEntriesRequest.StoreLocation = this.StoreCode;
    this.CurrentSaveMaterialConsumptionEntriesRequest.StoreName = this.StoreName;
    this.CurrentSaveMaterialConsumptionEntriesRequest.UserDepartment = AppData.Instance().SelectedFacilityName;
    this.CurrentSaveMaterialConsumptionEntriesRequest.ConsumptionGroup = this.Consumptioncode;
    this.CurrentSaveMaterialConsumptionEntriesRequest.consumptionGroupName = this.ConsumptionGroupName;
    this.CurrentSaveMaterialConsumptionEntriesRequest.ConsumptionItems = this.CurrentConsumpationData;
    this.actorservice.SaveMaterialConsumptionEntries(this.CurrentSaveMaterialConsumptionEntriesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            // this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            //this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();
            this.router.navigate(['healins/ConsumptionEntry']);
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            //this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            //this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  Finalize() {

    this.CurrentFinalizeConsumptionEntryRequest.ConditionalOperator = 10;
    this.CurrentFinalizeConsumptionEntryRequest.ConsumptionOrderCode = this.Code;
    this.actorservice.FinalizeConsumptionEntry(this.CurrentFinalizeConsumptionEntryRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            // this.Listview = true;
            //this.EditEmbryo = false;
            //this.LoadStoreData();
            //this.AddEmbryo = false;
            //this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();
            this.router.navigate(['healins/ConsumptionEntry']);
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            //this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            //this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            // this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  SelectedCareUnitCode: number;
  SelectedCareUnitName: string;

  Roleassign(event: any) {
    // alert(this.SelectedCareUnitCode);
    if (event != null) {


      this.SelectedCareUnitName = event;

    }

  }
  //alert(this.CurrentBillDetails.length);
  // CurrentBillDetailsEdit: BillDetails;
  Editrow(l: BillDetails) {
    //this.Add = false;

    //this.Edit = true;
    l.Edit = true;
    //this.CurrentBillDetailsEdit = new BillDetails();
    //this.CurrentBillDetailsEdit.rownumber = l.rownumber;
    //this.CurrentBillDetailsEdit.ServiceDescription = l.ServiceDescription;
    //this.CurrentBillDetailsEdit.quantity = l.quantity;
    //this.CurrentBillDetailsEdit.unitprice = l.unitprice;
    //this.CurrentBillDetailsEdit.discount = l.discount;
    //this.CurrentBillDetailsEdit.ItemRate = l.ItemRate;

  }
  delete(i: number) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      //this.deleterow(i);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  //deleterow(i: number) {
  //    this.CurrentBillDetails.splice(i);

  //}
  OnClear(l: BillDetails) {
    l.Edit = false;
  }
  //Payment() {
  //    const modalRef = this.modalService.open(NgbPaymentModal,
  //        {
  //            centered: true,
  //            size: "lg"

  //        })
  //    modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
  //    modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
  //    modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
  //    modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
  //    modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
  //    modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
  //    modalRef.componentInstance.BillDate = this.CurrentNewBillData.BillDate;
  //    modalRef.componentInstance.TotalBill = this.CurrentNewBillData.TotalBill;
  //    modalRef.componentInstance.NetPayable = this.CurrentNewBillData.NetPayable;
  //    modalRef.componentInstance.Discount = this.CurrentNewBillData.TotalDiscount;
  //    modalRef.componentInstance.ActorCode = this.CurrentNewBillData.ActorCode;
  //    modalRef.componentInstance.ChargeEntryCode = this.CurrentNewBillData.ChargeEntryCode;
  //    modalRef.componentInstance.BillStatus = this.CurrentNewBillData.BillStatus;
  //    modalRef.componentInstance.BillType = this.CurrentNewBillData.BillType;
  //    modalRef.componentInstance.BillSource = this.CurrentNewBillData.BillSource;
  //    modalRef.componentInstance.BranchName = this.CurrentNewBillData.BranchName;
  //    modalRef.componentInstance.BranchCode = this.CurrentNewBillData.BranchCode;
  //    modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;

  //    modalRef.componentInstance.Prescriber = this.SelectedPrescriber;
  //    modalRef.componentInstance.Refferal = this.SelectedReferral;

  //}


}
//export class BillDetails {
//  public ServiceDescription: string;
//  public Quantity: number;
//  public UnitPrice: number;
//  public Discount: number;
//  public ItemRate: number;
//  public RowNumber: number;
//  public Edit: boolean;
//  public ServiceCode: number;
//  public ItemType: string;
//  public ItemGroup: string;
//  public GroupName: string;
//  public IsPackage: boolean;
//  public PackageName: string;
//  public ChargeItemCode: number;
//  public DiscountAllowed: boolean;

//}
//export class PrescribingDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
//export class ReferringDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
//export class ConsumpationData {

//  public ItemCode: number;
//  public Quantity: number;
//  public ItemName: string;
//  public Uom: string;
//  public ItemCost: number;
//  public Code: number;
//  public Material: number;
//  public MaterialGroup: number;
//  public Supplier: number;
//  public SupplierName: string;
//  public MaterialBatchStorage: number;
//  //public ItemCost: number;
//  public ExpiryDate: Date;
//  public SupplierBatchDetails: string;
//  public Remarks: string;
//  public GroupCode: number;
//  public SupplierMaterialBatch: number;
//}
